import React from "react";
import { Button, Typography, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const helper = (showModal, projectData) => {
  const navigate = useNavigate();

  // Check if today is the actual completion date
  const isCompletionDateToday = projectData?.endDate
    ? dayjs(projectData.endDate).isSame(dayjs(), "day")
    : false;

  const columns = [
    {
      title: projectData?.group?.groupType === 2 ? "Group Member Name" : "Participant Name",
      dataIndex: "learnerName",
      key: "learnerName",
    },
    {
      title: "Assign Task",
      key: "assignTask",
      render: (_, record) => (
        <Tooltip
          title={isCompletionDateToday ? "Tasks cannot be assigned as the training ends today." : null}
        >
          <Button type="link" onClick={() => showModal(record)} disabled={isCompletionDateToday}>
            Assign Task
          </Button>
        </Tooltip>
      ),
    },
    {
      title: "Progress Report",
      key: "progressReport",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() =>
            navigate(`/status-report/${record.id}`, {
              state: { learnerName: record.learnerName },
            })
          }
        >
          View Reports{" "}
          {record.statusReportAlertCount > 0 && (
            <Typography.Text type="danger">({record.statusReportAlertCount})</Typography.Text>
          )}
        </Button>
      ),
    },
    {
      title: "Issues & Challenges",
      key: "issuesChallenges",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() =>
            navigate(`/issues-and-report/${record.id}`, {
              state: { learnerName: record.learnerName },
            })
          }
        >
          Issues & Challenges{" "}
          {record.issueAlertCount > 0 && (
            <Typography.Text type="danger">({record.issueAlertCount})</Typography.Text>
          )}
        </Button>
      ),
    },
  ];

  return { columns };
};

export default helper;
